import Projects from "./components/Projects";
import "./index.css";

function Project() {
  return (
    <>
      <Projects />
    </>
  );
}

export default Project;
